import { z } from 'zod';

export const CavernsSubmodeKeySchema = z.enum(['GAME_SUBMODE_caverns1man','GAME_SUBMODE_caverns2man','GAME_SUBMODE_caverns3man','GAME_SUBMODE_caverns5man','GAME_SUBMODE_caverns7man','GAME_SUBMODE_caverns11man']);

export type CavernsSubmodeKeyType = `${z.infer<typeof CavernsSubmodeKeySchema>}`

export default CavernsSubmodeKeySchema;
